import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import { Bet } from "@models";

import { THEME_SETTINGS } from "@theme-settings";

import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";

export const BetDetailsModalShareButton = observer(
	function BetDetailsModalShareButton(props: {
		bet: Bet;
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
		btnTiny?: boolean;
	}) {
		const store = props.store;

		if (!THEME_SETTINGS.features.isBetSlipShareEnabled) {
			return null;
		}

		const btnClasses = classNames("btn", {
			"btn--square btn--square--xxsml btn--ghost btn--icon":
				props.btnTiny,
			"btn--wrap btn--wrap--base btn--block btn--secondary--inverted btn--icon bet__btn":
				!props.btnTiny,
			"bet__btn--slip": props.bet,
		});

		const iconClasses = classNames("u-icon u-icon--share", {
			"u-icon--sml": props.btnTiny,
			"u-icon--med u-align--v--middle": !props.btnTiny,
		});

		return (
			<>
				<button
					type="button"
					className={btnClasses}
					onClick={() => {
						store.shareBetSlipStore.onBetDetailsShare(props.bet);
						store.onShareOpen();
					}}
				>
					<i className={iconClasses}></i>
				</button>
			</>
		);
	}
);
